module.exports = __webpack_public_path__ + "static/media/commission_1.16811faa.svg";